var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SuggestAction } from '@yandex-taxi/js-integration-api';
import { getSuggest } from './selectors';
export var updateSuggestReducer = function (state, _a) {
    var _b;
    var idx = _a.idx, suggest = _a.suggest;
    return (__assign(__assign({}, state), { suggest: __assign(__assign({}, state.suggest), (_b = {}, _b[idx] = __assign(__assign({}, state.suggest[idx]), suggest), _b)) }));
};
export var findNextGeoObject = function (payload) {
    var _a;
    var response = payload.data, request = payload.request;
    // для зеро саджеста не нужно выбирать гео-объект,
    // иначе если в саджесте будет 1 адрес,
    // то он сразу улетит в драфт
    if (request.action === 'zero_suggest') {
        return;
    }
    var suggest = (response === null || response === void 0 ? void 0 : response.results) || [];
    // попробуем найти адрес по айдишнику
    var selectedId = (_a = response === null || response === void 0 ? void 0 : response.position_choices) === null || _a === void 0 ? void 0 : _a.selected_point_id;
    var selectedObj = selectedId && suggest.find(function (geoObject) { return geoObject.id === selectedId; });
    // или возьмем единственный адрес
    var firstObj = suggest.length === 1
        ? suggest[0]
        : undefined;
    // по итогу возьмем что получится, или ничего
    return selectedObj || firstObj;
};
export var setSuggestReducer = function (state, payload) {
    var _a;
    var _b;
    var request = payload.request, prevGeoObject = payload.prevGeoObject;
    var response = payload.data;
    var idx = payload.idx;
    var suggest = getSuggest(idx, state);
    // по дефолту не доверяем тому что вернула ручка саджеста
    var nextSuggest = (response === null || response === void 0 ? void 0 : response.results) || [];
    // ключ саджеста, который будем обновлять
    var key = request.action === SuggestAction.ZERO_SUGGEST
        ? 'zeroSuggest'
        : 'userSuggest';
    if (prevGeoObject && nextSuggest.length === 1) {
        // если из саджеста вернулся один результат, то
        // берем первый адрес из саджеста
        var nextGeoObject_1 = nextSuggest[0];
        // чтобы сохранить предыдущий саджест
        // просто заменим в существующем саджесте объект по которому кликнули
        // на объект, который пришел из ответа ручки
        var fromSuggest = suggest === null || suggest === void 0 ? void 0 : suggest.userSuggest;
        if ((_b = suggest === null || suggest === void 0 ? void 0 : suggest.zeroSuggest) === null || _b === void 0 ? void 0 : _b.includes(prevGeoObject)) {
            key = 'zeroSuggest';
            fromSuggest = suggest.zeroSuggest;
        }
        if (fromSuggest) {
            nextSuggest = fromSuggest.map(function (geoObject) { return (geoObject === prevGeoObject
                ? nextGeoObject_1
                : geoObject); });
        }
    }
    return updateSuggestReducer(state, {
        idx: idx,
        suggest: (_a = {},
            _a[key] = nextSuggest.length ? nextSuggest : undefined,
            _a),
    });
};
